module.exports = __webpack_public_path__ + "img/appstore.02c47b37.svg";